import { type ReactNode } from 'react';
import { EnterpriseSidebar } from './EnterpriseSidebar';

interface EnterpriseLayoutProps {
  children: ReactNode;
}

export function EnterpriseLayout({ children }: EnterpriseLayoutProps) {
  return (
    <div className="flex min-h-screen bg-slate-50">
      <EnterpriseSidebar />
      <main className="flex-1 p-6 lg:p-8">
        {children}
      </main>
    </div>
  );
}
